module.exports = __webpack_public_path__ + "img/tree_cendor_go_module.65092c6c.png";